import type { App } from 'vue';
import { IconDefinition, library } from '@fortawesome/fontawesome-svg-core';
import {
  faAddressBook,
  faArrowDown,
  faArrowLeft,
  faArrowUp,
  faBell,
  faBriefcase,
  faBullhorn,
  faCalendarCheck,
  faCheckCircle,
  faCircle,
  faCog,
  faCommentDots,
  faComments,
  faCopy,
  faDownload,
  faEnvelope,
  faEuroSign,
  faExclamationTriangle,
  faExternalLinkAlt,
  faEye,
  faFile,
  faFlag,
  faHome,
  faIdCardAlt,
  faInfo,
  faInfoCircle,
  faKey,
  faList,
  faMapMarkerAlt,
  faMinus,
  faNewspaper,
  faPaperPlane,
  faPaperclip,
  faPen,
  faPencilAlt,
  faPhone,
  faPlus,
  faPollH,
  faRuler,
  faSave,
  faSearch,
  faSignInAlt,
  faSignOutAlt,
  faSlidersH,
  faStar,
  faSync,
  faTable,
  faThumbsDown,
  faThumbsUp,
  faTools,
  faTrash,
  faUpload,
  faUser,
  faUserCheck,
  faUserFriends,
  faUsers,
  faUsersCog,
  faUserTimes,
} from '@fortawesome/free-solid-svg-icons';
import { faMagnifyingGlassPlus, faMinusCircle } from '@fortawesome/pro-regular-svg-icons';
import { faBuildings, faCalendarPen, faCircleExclamation, faClockRotateLeft } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';

library.add(
  faHome,
  faPaperPlane,
  faPen,
  faTable,
  faList,
  faBell,
  faEnvelope,
  faUser,
  faSignOutAlt,
  faSignInAlt,
  faSync,
  faSearch,
  faUsers,
  faCopy,
  faInfo,
  faInfoCircle,
  faCheckCircle,
  faKey,
  faMapMarkerAlt,
  faKey,
  faUserFriends,
  faFile,
  faIdCardAlt,
  faAddressBook,
  faUsersCog,
  faArrowLeft,
  faStar,
  faComments,
  faArrowDown,
  faArrowUp,
  faCommentDots,
  faMinus,
  faCircle,
  faFlag,
  faThumbsDown,
  faThumbsUp,
  faPaperclip,
  faCog,
  faSave,
  faCalendarCheck,
  faPhone,
  faSlidersH,
  faCalendarCheck,
  faBriefcase,
  faTrash,
  faPencilAlt,
  faUserTimes,
  faUserCheck,
  faExternalLinkAlt,
  faBullhorn,
  faNewspaper,
  faPlus,
  faEye,
  faPollH,
  faRuler,
  faTools,
  faEuroSign,
  faCalendarPen as IconDefinition,
  faExclamationTriangle,
  faDownload,
  faUpload,
  faMinusCircle as IconDefinition,
  faCircleExclamation as IconDefinition,
  faBuildings as IconDefinition,
  faClockRotateLeft as IconDefinition,
  faMagnifyingGlassPlus as IconDefinition
);

// `@fortawesome/vue-fontawesome` passa dalla 0.1 alla 3: cambia il pacchetto sotto, non l'uso.
// La registrazione e identica, cambia solo cosa le si passa - `app` invece del costruttore globale.
const initFontAwesome = (app: App) => {
  app.component('font-awesome-icon', FontAwesomeIcon);
};

export default initFontAwesome;
